import React from 'react';
import KeyTakeaways from '../templates/KeyTakeaways';
import { socmintTakeaways } from '../data';

const SOCMINTTakeaways: React.FC = () => {
  return <KeyTakeaways data={socmintTakeaways} />;
};

export default SOCMINTTakeaways;